import { hotEvents } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";

export default function EventsSection() {
  return (
    <section id="events" className="w-full bg-background-50 py-14 md:py-20 scroll-mt-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          kicker="HOT 热议"
          title="热门事件图集"
          desc="把讨论度最高的事件照片整理成一本本图集。按事件持续收录现场生图、路透照与抓拍瞬间，一次补齐全过程。"
        />

        <div className="mt-10 space-y-6 md:space-y-8">
          {hotEvents.map((ev, i) => (
            <article
              key={ev.id}
              className="group grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 items-stretch rounded-xl overflow-hidden bg-background-100 border border-background-200"
            >
              <div
                className={`relative w-full overflow-hidden min-h-[220px] md:min-h-[300px] ${
                  i % 2 === 1 ? "md:order-2" : ""
                }`}
              >
                <img
                  src={ev.img}
                  alt={`${ev.title}现场高清图集封面`}
                  className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                {ev.featured && (
                  <span className="absolute top-4 left-4 flex items-center gap-1 px-2.5 py-1 rounded text-[11px] font-semibold text-background-50 bg-accent-500 whitespace-nowrap">
                    <i className="ri-fire-line"></i> 头条图集
                  </span>
                )}
                <span className="absolute bottom-4 right-4 inline-flex items-center gap-1 px-2.5 py-1 rounded text-[11px] font-medium text-background-100 bg-foreground-950/70 backdrop-blur-sm whitespace-nowrap">
                  <i className="ri-image-line"></i> {ev.pics} 张高清
                </span>
              </div>

              <div className="flex flex-col justify-center p-5 md:p-8">
                <span className="inline-flex self-start px-3 py-1 rounded-full text-xs font-semibold text-background-50 bg-primary-500 whitespace-nowrap">
                  {ev.tag}
                </span>
                <h3 className="mt-4 text-xl md:text-2xl font-heading font-bold text-foreground-950 leading-snug">
                  {ev.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{ev.desc}</p>
                <div className="mt-5 flex items-center justify-between">
                  <span className="inline-flex items-center gap-1 text-sm text-foreground-500">
                    <i className="ri-eye-line"></i> {ev.reads} 人看过
                  </span>
                  <button
                    onClick={() =>
                      window.dispatchEvent(
                        new CustomEvent("chigua:toast", { detail: `正在打开「${ev.title}」完整图集…` })
                      )
                    }
                    className="inline-flex items-center gap-1.5 h-10 px-4 rounded-md bg-foreground-950 text-background-50 text-sm font-semibold hover:bg-primary-600 transition whitespace-nowrap cursor-pointer"
                  >
                    查看图集 <i className="ri-arrow-right-up-line"></i>
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}